import { Icon } from 'ant-design-vue'

const GardenIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1312673_8xyb3l4pmvg.js',
})

export { GardenIcon }
